
































































































// vendor
import { computed, defineComponent, PropType, ComputedRef } from "@vue/composition-api";
// project
import { LabelBadge } from "@/components.generic/label-badge";
// local
import { default as LabelDropdown } from "./label-dropdown.vue";
import * as Utils from "../../utils";

type Mod = "all"|"in";

type ValueType = {
	mod:Mod|null;
	include:string[];
	exclude:string[];
};

type LabelOption = {
	id:string;
	name:string;
	color:string;
};

type DrawerConfig = {
	options:LabelOption[]|ComputedRef<LabelOption[]>;
};

export default defineComponent({
	emits: [
		"input",
	],
	props: {
		value: {
			type:Object as PropType<ValueType>,
			default:() => ({
				mod:null,
				include:[],
				exclude:[],
			})
		},
		config:{
			type:Object as PropType<DrawerConfig>,
			default:() => ({ options:[] }),
		},
	},
	components: {
		LabelBadge,
		LabelDropdown,
	},
	setup(props, context) {

		// console.log(props.config.options);
		// const qq = Utils.parseLabelQuery("all;l1,l2,l3-l5,l6");
		
		const options = computed(() => {
			if(Array.isArray(props.config.options)){
				return props.config.options;
			}
			return props.config.options.value;
		});

		// const selected = computed(() => {
		// 	const items = Array.from(new Set(val.value.split(",")))
		// 	.map(id => options.value.find(o => o.id === id));
		// 	return items.filter(it => it !== undefined) as LabelOption[];
		// });
		const selected = computed(() => {
			const items = Array.from(new Set(props.value.include))
			.map(id => options.value.find(o => o.id === id));
			return items.filter(it => it !== undefined) as LabelOption[];
		});

		const available = computed(() => {
			return options.value.filter(o => selected.value.findIndex(so => so.id === o.id) < 0);
		});

		const mod = computed(() => {
			// const s = props.value.split(";");
			// if(s.length > 1){
			// 	return s[0];
			// }
			// return "all";
			return props.value.mod;
		});

		

		// const val = computed(() => {
		// 	const s = props.value.split(";");
		// 	return s.length > 1 ? s[1] : s[0];
		// });

		const modOptions = computed(() => {
			return [
				{ value:"in", text:"Any" },
				{ value:"all", text:"All" },
				// { value:"nin", text:"Not" },
			];
		});

		const toggleInclude = (id:string) => {
			const i = props.value.include.findIndex(v => v === id);
			if(i > -1){ props.value.include.splice(i, 1); }
			else { props.value.include.push(id); }
			context.emit("input", props.value);
		};

		const toggleExclude = (id:string) => {
			const i = props.value.exclude.findIndex(v => v === id);
			if(i > -1){ props.value.exclude.splice(i, 1); }
			else { props.value.exclude.push(id); }
			context.emit("input", props.value);
		};

		const setMode = (m:Mod|null) => {
			props.value.mod = m;
			context.emit("input", props.value);
		};

		// const add = (id:string) => {
		// 	if(props.value.includes(id)){ return; } // already included
		// 	let nv = selected.value.map(sv => sv.id);
		// 	nv.push(id);
		// 	const v = nv.join(",");
		// 	context.emit("input", (mod.value ? mod.value + ";" : "") + v);
		// };

		// const remove = (id:string) => {
		// 	const nv = selected.value.filter(s => s.id !== id).map(s => s.id).join(",");
		// 	context.emit("input", (mod.value ? mod.value + ";" : "") + nv);
		// };

		return {
			setMode,
			selected,
			available,
			// add,
			mod,
			// remove,
			modOptions,
			options,
			toggleInclude,
			toggleExclude,
		};
	},
});
